import React from "react";
import { CircularProgress, Box } from "@mui/material";

export const LoadingIndicator = () => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      margin: "16px 0",
      width: "100%",
    }}
  >
    <CircularProgress />
  </Box>
);
